import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from '@reduxjs/toolkit'

export const planSlice =  createSlice({
    name:"Plan",
    initialState:{
        plans:[""],
    },
    reducers:{
        SetPlan(state, action: PayloadAction<Array<string>>){
            state.plans = action.payload;

        }
    }
});

export const { SetPlan } =planSlice.actions
export default planSlice.reducer